import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .container {
    padding: 15px;
  }

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .info-description {
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .empty-state {
    display: flex;
    justify-content: center;
    padding: 2rem;
    color: var(--sl-color-neutral-600);
    font-size: 0.9rem;
  }

  .data-table-container {
    overflow-x: auto;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
  }

  .data-table th,
  .data-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .data-table th {
    font-weight: 600;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
    background: var(--sl-color-neutral-50);
  }

  .data-table td {
    color: var(--sl-color-neutral-900);
    font-size: 0.875rem;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .clickable-row:hover {
    background-color: var(--sl-color-neutral-50);
  }

  .status-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .status-badge.open {
    background: var(--sl-color-primary-100);
    color: var(--sl-color-primary-700);
  }

  .status-badge.in-progress {
    background: var(--sl-color-warning-100);
    color: var(--sl-color-warning-700);
  }

  .status-badge.completed {
    background: var(--sl-color-success-100);
    color: var(--sl-color-success-700);
  }

  .status-badge.awaiting-parts {
    background: var(--sl-color-danger-100);
    color: var(--sl-color-danger-700);
  }

  .status-badge.unknown {
    background: var(--sl-color-neutral-200);
    color: var(--sl-color-neutral-600);
  }

  .priority-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .priority-badge.low {
    background: var(--sl-color-neutral-100);
    color: var(--sl-color-neutral-600);
  }

  .priority-badge.medium {
    background: var(--sl-color-primary-100);
    color: var(--sl-color-primary-700);
  }

  .priority-badge.high {
    background: var(--sl-color-warning-100);
    color: var(--sl-color-warning-700);
  }

  .priority-badge.critical {
    background: var(--sl-color-danger-100);
    color: var(--sl-color-danger-700);
  }
`;

